<div class="container-fluid mt-2">
    <div class="row">
        <!-- LEFT SIDE: BILL FORM -->
        <div class="col-md-6">
            <div class="bill-form-container">
                <h3 class="form-title">Create Bill</h3>

                <form [formGroup]="billForm" class="p-fluid">
                    <div class="row g-3">
                        <!-- Patient Name Search -->
                        <div class="col-md-6">
                            <label>Patient Name</label>
                            <p-autoComplete [(ngModel)]="selectedPatient" [suggestions]="patientsList"
                                (completeMethod)="searchPatients($event)" [ngModelOptions]="{ standalone: true }"
                                (onSelect)="onPatientSelect($event)" field="full_name"
                                placeholder="Search by name, number, or contact" [forceSelection]="true"
                                emptyMessage="No patients found" class="w-100">
                            </p-autoComplete>
                        </div>

                        <!-- Date Selection -->
                        <div class="col-md-6">
                            <label>Date</label>
                            <p-calendar formControlName="date" dateFormat="dd-mm-yy"></p-calendar>
                        </div>

                        <!-- Prescription Title -->
                        <div class="col-md-4">
                            <label>Prescription For</label>
                            <input type="text" pInputText formControlName="prescriptionTitle"
                                placeholder="e.g., Homeopathy Treatment" class="w-100" />
                        </div>

                        <!-- Prescription Duration -->
                        <div class="col-md-3">
                            <label>Prescription Duration</label>
                            <input type="text" pInputText formControlName="prescriptionDuration"
                                placeholder="e.g., 30 days, 3 months" class="w-100" />
                        </div>

                        <!-- Consultation Fee -->
                        <div class="col-md-3">
                            <label>Consultation Fee (₹)</label>
                            <p-inputNumber formControlName="consultationFee" mode="currency" currency="INR"
                                currencyDisplay="symbol" [useGrouping]="true"></p-inputNumber>
                        </div>

                        <!-- Discount % -->
                        <div class="col-md-2">
                            <label>Discount (%)</label>
                            <p-inputNumber [(ngModel)]="discountPercentage" [ngModelOptions]="{ standalone: true }"
                                [min]="0" [max]="100"></p-inputNumber>
                        </div>

                        <!-- Notes -->
                        <div class="col-md-12">
                            <label>Notes / Additional Info</label>
                            <textarea rows="3" pInputTextarea formControlName="notes"
                                placeholder="Any additional notes for the bill..."></textarea>
                        </div>
                    </div>
                </form>

                <!-- MEDICINES SECTION -->
                <div class="medicines-section mt-4">
                    <h4>Medicines</h4>

                    <div class="row g-2 mb-3">
                        <!-- Select Medicine Dropdown -->
                        <div class="col-md-8">
                            <label>Select Medicine</label>
                            <p-autoComplete [(ngModel)]="selectedMedicinesToAdd" [suggestions]="filteredMedicines"
                                (completeMethod)="searchMedicines($event)"
                                [ngModelOptions]="{ standalone: true }" field="name"
                                placeholder="Select or search medicine" [forceSelection]="true">
                            </p-autoComplete>
                        </div>

                        <!-- Add Medicine Button -->
                        <div class="col-md-4">
                            <label>&nbsp;</label>
                            <div class="d-flex gap-2">
                                <button pButton type="button" icon="pi pi-plus" label="Add"
                                    class="view-button-success" (click)="addMedicine()"></button>
                                <button pButton type="button" icon="pi pi-random" label="Random" class="view-button-info"
                                    (click)="addRandomMedicine()" pTooltip="Add a random medicine"></button>
                            </div>
                        </div>
                    </div>

                    <!-- Medicines Table -->
                    <p-table [value]="medicinesList" class="medicines-table">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Medicine</th>
                                <th>Quantity</th>
                                <th>Dose</th>
                                <th></th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-medicine let-rowIndex="rowIndex">
                            <tr>
                                <td>
                                    <input type="text" pInputText [(ngModel)]="medicine.name"
                                        (change)="updateMedicineField(rowIndex, 'name', medicine.name)" class="w-100" />
                                </td>
                                <td>
                                    <input type="text" pInputText [(ngModel)]="medicine.quantity"
                                        (change)="updateMedicineField(rowIndex, 'quantity', medicine.quantity)" />
                                </td>
                                <td>
                                    <input type="text" pInputText [(ngModel)]="medicine.dose"
                                        (change)="updateMedicineField(rowIndex, 'dose', medicine.dose)" class="w-100" />
                                </td>
                                <td>
                                    <button pButton type="button" icon="pi pi-trash" class="view-button-danger p-button-sm"
                                        (click)="removeMedicine(rowIndex)"></button>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="4" class="text-center text-muted p-3">
                                    No medicines added yet. Add medicines to generate bill.
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <!-- Paper Size Option & Action Buttons -->
                <div class="mt-4 d-flex gap-3 align-items-center">
                    <div class="d-flex gap-2 align-items-center">
                        <label class="mb-0">Paper Size:</label>
                        <p-radioButton name="paperSize" value="a5" label="A5 (Half)" [(ngModel)]="selectedPaperSize"></p-radioButton>
                        <p-radioButton name="paperSize" value="a4" label="A4 (Full)" [(ngModel)]="selectedPaperSize"></p-radioButton>
                    </div>
                    <button pButton type="button" icon="pi pi-file-pdf" label="Generate PDF" class="view-button-success"
                        (click)="generateBill()"></button>
                    <button pButton type="button" icon="pi pi-replay" label="Reset" class="view-button-danger"
                        (click)="resetBill()"></button>
                </div>
            </div>
        </div>

        <!-- RIGHT SIDE: BILL PREVIEW -->
        <div class="col-md-6">
            <div class="bill-preview medical-bill">
                <!-- HEADER -->
                <div class="header">
                    <img src="{{ logo }}" alt="logo" />
                    <div class="clinic-info">
                        <small
                            >Sr. No. 2/14, Opp. Purandar (MHADA) Building, Near
                            Paneerwala,</small
                        >
                        <small>Maharshi Nagar, Pune, Maharashtra – 411037</small>
                        <small
                            >Ph: 8070 7080 01/02/03 | Email:
                            drshaileshsancheti&#64;gmail.com</small
                        >
                        <small></small>
                    </div>
                </div>

                <div class="sub-header">
                    <div class="specialization">
                    SPECIALIZED IN THYROID, HAIR, SKIN & DIABETES
                    </div>
                    <div class="timing">
                    Time: Morning - 11 am to 2 pm | Evening - 6 pm to 8 pm
                    </div>
                </div>

                <!-- PATIENT INFO -->
                <table class="info-table">
                    <tr>
                    <td><strong>Patient Name:</strong></td>
                    <td>{{ billForm.get('patientName')?.value || 'N/A' }}</td>
                    <td><strong>Date:</strong></td>
                    <td>{{ billForm.get('date')?.value | date:'dd MMM yyyy' }}</td>
                    </tr>
                    <!-- <tr *ngIf="billForm.get('prescriptionTitle')?.value || billForm.get('prescriptionDuration')?.value.trim() !== ''"> -->
                    <tr>
                    <td><strong>Prescription For:</strong></td>
                    <td>{{ billForm.get('prescriptionTitle')?.value }}</td>
                    <td><strong>Prescription Duration:</strong></td>
                    <td>{{ billForm.get('prescriptionDuration')?.value }}</td>
                    </tr>
                </table>

                <!-- CONSULTATION FEE -->
                <table class="charges-table">
                    <thead>
                    <tr>
                        <th>Description</th>
                        <th class="right">Amount (₹)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Consultation Fee</td>
                        <td class="right">{{ billForm.get('consultationFee')?.value || 0 | currency:'INR' }}</td>
                    </tr>
                    </tbody>
                </table>

                <!-- MEDICINES TABLE -->
                <div *ngIf="medicinesList.length > 0">
                    <h5 class="section-title">Medicines Prescribed</h5>
                    <table class="medicines-bill-table">
                    <thead>
                        <tr>
                        <th>Medicine</th>
                        <th>Quantity</th>
                        <th>Dose</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let medicine of medicinesList">
                        <td>{{ medicine.name }}</td>
                        <td>{{ medicine.quantity }}</td>
                        <td>{{ medicine.dose }}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>

                <!-- SUMMARY -->
                <table class="summary-table">
                    <tr *ngIf="discountPercentage > 0">
                    <td>Discount ({{ discountPercentage }}%)</td>
                    <td class="right">-₹{{ getDiscountAmount() }}</td>
                    </tr>
                    <tr class="total-row">
                    <td>Total Amount</td>
                    <td class="right">₹{{ getTotalAmount() }}</td>
                    </tr>
                </table>

                <!-- Notes Display -->
                <div *ngIf="billForm.get('notes')?.value" class="bill-notes mt-3">
                    <small><strong>Notes:</strong></small>
                    <p>{{ billForm.get('notes')?.value }}</p>
                </div>
            </div>
        </div>
    </div>
</div>

